<div class="confirm-dialog-container">
  <p>Are you sure?</p>
  <p class="secondary-text">If you navigate away from this screen without choosing an enrollment option below, all benefit plan data you have entered for this employee will be lost.</p>
</div>
<div class="confirm-dialog-footer">
  <button id="stay-button" mat-flat-button class="mat-secondary" (click)="closeDialog({confirmFlag: false})">Stay</button>
  <button id="leave-button" mat-flat-button class="mat-primary ml-4" (click)="confirmAction()">Leave</button>
</div>
